<ms-scroll-adapter class="widget-pills" [scrollItems]="pills">
    <ul class="widget-pills-list">
        @for (item of pills; track item.id) {
            <li>
                <button ds-pill size="medium" [attr.data-menu-item-id]="item.id" [selected]="!!item.active" (click)="eventSelected(item)">
                    <ng-container ngProjectAs="[slot=start]" *ngTemplateOutlet="iconTemplate; context: { $implicit: item }" />
                    <span>{{ item.title }}</span>
                </button>
            </li>
        }
    </ul>
</ms-scroll-adapter>

<ng-template #iconTemplate let-pill>
    @if (pill.display === display.Logo) {
        <ms-competition-logo
            [sportId]="pill.sportId"
            [leagueId]="pill.itemId"
            [fallbackIcon]="pill.icon"
            [isLogoOverrideEnabled]="true"
            [imageProfile]="pill.context?.imageProfile" />
    } @else if (pill.icon) {
        <span [ngClass]="pill.icon"></span>
    }
</ng-template>
